import { render, staticRenderFns } from "./CustomerTable.vue?vue&type=template&id=f6ab0dce"
import script from "./CustomerTable.vue?vue&type=script&lang=ts"
export * from "./CustomerTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6ab0dce')) {
      api.createRecord('f6ab0dce', component.options)
    } else {
      api.reload('f6ab0dce', component.options)
    }
    module.hot.accept("./CustomerTable.vue?vue&type=template&id=f6ab0dce", function () {
      api.rerender('f6ab0dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/CustomerTable.vue"
export default component.exports